export default "__VITE_ASSET__DqDbTQzp__"